/**
 * Backend user-scoped analytics events from fruitful-all
 * `apps/backend/src/modules/event-tracking/events.ts` (`Events` there).
 *
 * Keep these string values in sync until the backend imports this package.
 */
export enum BackendUserEvent {
    SUBSCRIPTION_CREATED = 'Subscription Created',
    SUBSCRIPTION_CANCELED = 'Subscription Canceled',
    USER_CREATED = 'User Created',
    KYC_UPDATE = 'KYC Updated',
    IM_SELF_START_INTRO_SENT = 'Self-Start IM Intro Sent',
    BANKING_ADOPTION_MARKED_AS_COMPLETED = 'BankingAdoptionMarkedAsCompleted',
    REFERRAL_PAYOUT_POSTED = 'ReferralPayoutPosted',
    APEX_ACCOUNT_OPEN_DIGEST = 'ApexAccountOpenDigest',
    PASSWORD_RESET_REQUESTED = 'PasswordResetRequested',
    PASSWORD_CHANGED = 'PasswordChanged',
}
